module.exports = __webpack_public_path__ + "static/media/livechatProcess2.21b4eb98.png";